export enum LoginErrorEventName {
  INVALID_CODE = "INVALID_CODE",
}
